import { render, staticRenderFns } from "./homepage-radio.vue?vue&type=template&id=057c68a4&scoped=true&"
import script from "./homepage-radio.vue?vue&type=script&lang=js&"
export * from "./homepage-radio.vue?vue&type=script&lang=js&"
import style0 from "./homepage-radio.vue?vue&type=style&index=0&id=057c68a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c68a4",
  null
  
)

export default component.exports